(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        blog : $('.j-blog'),
        postsLoaded : false,


        splitText : {},

        banner: function(){
            var timeline = new TimelineMax();

            if (__.global.screen === "large") {


                if($('.o-index-sticky').length > 0 ){
                    $hasFeatured = true;
                }else{
                    $hasFeatured = false;
                }
                __.splitText.intro =  __.global.splitText($('.o-index-intro--content *'));
                
                if($hasFeatured){
                    __.splitText.feature_title =  __.global.splitText($('.o-index-featured--title'));
                    __.splitText.feature_text =  __.global.splitText($('.o-index-featured--text'));
                }
                timeline.add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1');
                timeline.add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right), '+=1');
                timeline.add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up));
                timeline.add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) );
                timeline.add(TweenMax.from('.o-index-intro--title', 0.4,  { opacity: 0 }) );
                __.global.staggerDisplay( __.splitText.intro, timeline);
            
                if($hasFeatured){
                    timeline.add(TweenMax.from('.o-index-sticky--background', 0.4, __.global.animations.fade.right ));
                    timeline.add(TweenMax.from('.o-index-featured--content', 0.4, __.global.animations.fade.up ), '-=0.4' );
                    __.global.staggerDisplay( __.splitText.feature_title, timeline);
                    __.global.staggerDisplay( __.splitText.feature_text, timeline);
                }

                timeline.add(TweenMax.from('.o-index-featured--read-more', 0.4, __.global.animations.slide.up ), '-=0.4' );
                timeline.add(TweenMax.from('.o-index-featured--read-more-line', 0.4, { width: 0 } ) );
                timeline.call(function() {
                    $('.o-index--posts').addClass('j-scroll-animated');
                });
                timeline.add(TweenMax.from('.o-index--wrapper', 0.4, { opacity: 0 } ) );
                timeline.call(function() {
                    __.global.completeLoadInAnimation();
                    __.splitText.intro.revert();
                    if($hasFeatured){
                        __.splitText.feature_title.revert();
                        __.splitText.feature_text.revert();
                    }
                });
                timeline.play();
            }else{
                timeline.add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1');
                timeline.add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down), '+=1');
                timeline.add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down));
            
                timeline.add(TweenMax.from('.o-index--wrapper', 0.4, { opacity: 0 } ) );
                timeline.call(function() {
                    __.global.completeLoadInAnimation();
                });
                timeline.play();
            }
        },

        loadNewsletter : function(){

           
            var timeline = new TimelineMax();
            
            timeline
                .add(TweenMax.from('.pg-index-newsletter', 0.4, __.global.animations.slide.left) )
                .add(TweenMax.from('.pg-index-newsletter--container', 0.4, __.global.animations.fade.up), '+=0.2')
                .staggerFrom(__.global.prepareText($('.pg-index-newsletter--title')), 0.4, __.global.animations.slide.up, 0 )
                .add(TweenMax.from('.pg-index-newsletter--form', 0.4, __.global.animations.slide.up), '+=0.2' );

            new ScrollMagic.Scene({
                duration: 400,
                offset: 100,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-index-newsletter'
            })
            .setTween(timeline)
            .addTo(__.controller);
        },
        loadPosts : function(){
            $('.o-index--posts').addClass('pg-index--display');
        },
        ajaxLoading: function(){
            
            // Categories
            __.blog.on('click','.j-blog--link', function(e){

                __.postsLoaded = false;
                e.preventDefault();
                var _this = $(this);
                var url = _this.attr('href');

                $([document.documentElement, document.body]).animate({
                    scrollTop: __.blog.find('.o-index--wrapper').offset().top - 100
                }, 500);

                __.getNewPage(url);
            });
        },
        getNewPage : function(url){
            __.blog.addClass('j-blog--loading');
            __.blog.removeClass('j-blog--failed');
            __.blog.find('.j-blog--posts').addClass('pg-index--unloading');
            __.blog.find('.j-blog--posts').css('min-height', __.blog.find('.j-blog--posts').height() );

            setTimeout(function(){
                
                if( __.postsLoaded === false ){
                    __.blog.find('.j-blog--posts').html("");
                }
            }, 1100);

            // ajax request a page
            var ajax = jQuery.ajax({
                dataType: 'text',
                url: url,
                success: function(rawhtml) {
                    __.setURL(url);
                    __.updateContent($(rawhtml));
                },
                error: function() {
                    __.blog.removeClass('j-blog--loading');
                    __.blog.addClass('j-blog--failed');
                }
            });
        }, 
        updateContent: function(newContent) {
            __.blog.find('.j-blog--categories').html(newContent.find('.j-blog--categories').html());
            __.blog.find('.j-blog--pagination').html(newContent.find('.j-blog--pagination').html());
            __.postsLoaded = true;
            __.blog.find('.j-blog--posts').css('min-height', '0' ).html(newContent.find('.j-blog--posts').html());

            $([document.documentElement, document.body]).animate({
                scrollTop: __.blog.find('.o-index--wrapper').offset().top - 100
            }, 500);
//
            setTimeout(function(){
                __.blog.find('.j-blog--posts').removeClass('pg-index--unloading');
                __.blog.removeClass('j-blog--loading');

            }, 300);
        },

        // Sets the url in the location bar to match the new content
        setURL: function(url) {
            history.pushState({}, '', url);
        },
        // Function that runs on load
        loadAnimations: function() {
            
            window._animations.base.footerAnimations();

        },
        // Function to call to setup functionality
        setup: function() {
            __.banner();
            __.ajaxLoading();
            __.loadAnimations();//
            __.loadNewsletter();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.author = __;
})(jQuery); 